<template>
  <div>
    <FadeTransition :duration="200" mode="out-in">
      <nuxt></nuxt>
    </FadeTransition>
  </div>
</template>

<script>
import { FadeTransition } from 'vue2-transitions'
export default {
  name: 'CoreView',
  components: {
    FadeTransition,
  },
  metaInfo() {
    return {
      title: 'Vue Material Dashboard by CreativeTim',
    }
  },
}
</script>
